import React from "react";
import "./sections.scss";

function AudioSec({item}){
    return(
        <div className="audio-content" style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            {/*<audio style={{width:"100%"}}  src="https://www.w3schools.com/tags/horse.mp3" controls autoPlay muted/>*/}
            {/*<audio style={{width:"100%"}}  src={item.items[0].audio} controls autoPlay muted/>*/}
            <audio controls autoPlay muted >
                    <source src={item.items[0].audio} type="audio/mpeg"/>
                        Your browser does not support the audio element.
            </audio>
        </div>
    )
}

export default AudioSec
